import React from "react";
import { registrationSuccessImage } from "../../../../../assets";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
	const navigate = useNavigate();
	return (
		<div className="account-successfully-created" id="account-successfully-created">
			<img src={registrationSuccessImage} alt="" />
			<h3>Congratulations</h3>
			<span>Account has been registered successfully</span>
			<button onClick={() => navigate("/login")}>Login</button>
		</div>
	);
};

export default SuccessPage;
